// extracted by mini-css-extract-plugin
module.exports = {"image":"dB","image-placeholder":"dC","imagePlaceholder":"dC"};